import { OrderSummarySupplyAddress } from './OrderSummarySupplyAddress';
import { OrderSummaryEnergyNeeds } from './OrderSummaryEnergyNeeds';
import { OrderSummaryPersonalDetails } from './OrderSummaryPersonalDetails';
import { OrderSummaryPsrDetails } from './OrderSummaryPsrDetails';
import { OrderSummaryPaymentDetails } from './OrderSummaryPaymentDetails';
import { OrderSummaryTariffDetails } from './OrderSummaryTariffDetails';

export const OrderSummaryContent = () => {
  return (
    <>
      <OrderSummarySupplyAddress />
      <OrderSummaryEnergyNeeds />
      <OrderSummaryPersonalDetails />
      <OrderSummaryPsrDetails />
      <OrderSummaryPaymentDetails />
      <OrderSummaryTariffDetails />
    </>
  );
};

export default OrderSummaryContent;
